import { PostApiWithAuthorizationAction } from "constantFunctions/apiActions";
import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { DropdownList } from "react-widgets";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Input,
  Label
} from "reactstrap";
import { validateSendGiftForm } from "constantFunctions/formValidations";

function SendGiftModal(props) {
  const [giftReceiverId, setGiftReceiverId] = useState(props.data ? props.data.giftReceiverId : null);
  const [amount, setAmount] = useState(props.data ? props.data.amount : "");
  const [description, setDescription] = useState(props.data ? props.data.description : "");

  const sendGiftHandler = (e) => {
    let body = {
        giftReceiverId: giftReceiverId,
        amount: amount.trim(),
        description: description.trim()
    };
    let validation = validateSendGiftForm(body);
    if (validation.success) {
      let url = "gift-receivers/gifts-history/send-gift/" + giftReceiverId;
      if (props.data && props.data.id !== 0) {
        url = "gift-receivers/gifts-history/update-gift/" + props.data.id;
      }
      PostApiWithAuthorizationAction(url, body)
      .then((res) => {
        if (res.err) {
          toast.error(res.err, {
            position: toast.POSITION.TOP_CENTER,
          });
        } else {
          let redirectUrl = "/portal/gift-receivers/gifts-history";
          if (props.data && props.data.id !== 0) {
            redirectUrl = "/portal/gift-receivers/gifts-history?id=" + props.data.giftReceiverId;
            props.reloadHistory();
          }
          props.toggle(e);
          props.history.push(redirectUrl);
        }
      })
      .catch((err) => {
        if (err.status === 440) {
          toast.error(err.message, { position: toast.POSITION.TOP_CENTER });
          props.history.push("/auth/login");
        } else {
          toast.error("Something went wrong! /n Please clear and retry", {
            position: toast.POSITION.TOP_CENTER,
          });
        }
      });
    } else {
      toast.error(validation.err, {
        position: toast.POSITION.TOP_CENTER,
        closeOnClick: true,
        autoClose: 8000,
      });
    }
  };

  return (
    <Modal isOpen={props.show} toggle={props.toggle}>
      <ModalHeader toggle={props.toggle}>
        <i className="fas fa-hand-holding-usd"></i> Send A Gift
      </ModalHeader>
      <ModalBody>
        {props.data.giftReceiverId === 0 && (
            <FormGroup className="mb-3">
                <Label className="form-control-label" for="b_name">
                    Gift Receiver
                </Label>
                <DropdownList
                    id="giftReceiver"
                    data={props.giftReceivers}
                    placeholder="Gift Receiver"
                    valueField="id"
                    textField={item => `${item.firstName} ${item.lastName}`} 
                    value={giftReceiverId}
                    onChange={(e) => setGiftReceiverId(e.id)}
                />
            </FormGroup>
        )}
        <FormGroup className="mb-3">
            <Label className="form-control-label" for="amount">Amount</Label>
            <Input
                id="amount"
                type="number"
                placeholder="Amount"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
            />
        </FormGroup>
        <FormGroup className="mb-0">
            <Label className="form-control-label" for="description">Description</Label>
            <Input
                id="description"
                type="textarea"
                placeholder="Description"
                value={description}
                rows={4}
                onChange={(e) => setDescription(e.target.value)}
            />
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button
        id="add-btn"
          color="primary"
          onClick={sendGiftHandler}
          disabled={amount.length === 0}
        >
            Send
        </Button>{" "}
        <Button color="secondary" onClick={props.toggle}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default SendGiftModal;
